export enum AppLocale {
  en = 'en',
}
